import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import Swal from 'sweetalert2'
import OptimizedImage from '../OptimizedImage'

export default function UserKyc() {
  const [data, setData] = useState([])
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  // --- IMAGE PREVIEW STATE ---
  const [previewImage, setPreviewImage] = useState(null);

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  
  let baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;
  if (baseUrl && !baseUrl.endsWith('/')) {
    baseUrl += '/';
  }

  const access_token = localStorage.getItem("token")
  const headers = { Authorization: `Bearer ${access_token}` }

  const All = () => {
    axios.get(`${baseUrl}aadharcard/all/all/all?page=${pageNumber}&_limit=${limit}`, { headers })
      .then((res) => {
        setData(res.data.admin || [])
        setNumberOfPages(res.data.totalPages || 0)
      })
      .catch(err => console.error("Error fetching data", err))
  }

  useEffect(() => {
    All()
  }, [pageNumber, limit])

  const setpageLimit = (event) => {
    setLimit(event.target.value);
    setPageNumber(1);
  }

  const handlePageClick = (data) => {
    setPageNumber(data.selected + 1);
  };

  // --- SWEETALERT UPDATED STATUS FUNCTION ---
  const updateStatus = (Id, status) => {
    const actionText = status === 'verified' ? 'Approve' : 'Reject';
    const confirmButtonColor = status === 'verified' ? '#15803d' : '#be123c';

    Swal.fire({
      title: `Are you sure?`,
      text: `Do you want to ${actionText} this KYC request?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: confirmButtonColor,
      cancelButtonColor: '#64748b',
      confirmButtonText: `Yes, ${actionText} it!`,
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.patch(`${baseUrl}aadharcard/${Id}`, { verified: status }, { headers })
          .then(() => {
            Swal.fire({
              title: 'Success!',
              text: `User KYC has been ${status} successfully.`,
              icon: 'success',
              confirmButtonColor: '#57155a'
            });
            All();
          })
          .catch(err => {
            Swal.fire({
              title: 'Error!',
              text: 'Could not update status. Please try again.',
              icon: 'error',
              confirmButtonColor: '#57155a'
            });
          });
      }
    });
  }

  const dateFormat = (e) => {
    if (!e) return "N/A";
    const date = new Date(e);
    return date.toLocaleString('default', { month: 'short', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
  }

  return (
    <div className="kyc-page-container p-2 p-md-4">
      <style>{`
        .kyc-page-container { background: #f0f2f5; min-height: 100vh; font-family: 'Poppins', sans-serif; }
        .kyc-card { background: #ffffff; border-radius: 20px; overflow: hidden; box-shadow: 0 10px 25px rgba(0,0,0,0.1); border: none; margin-bottom: 20px; }
        
        .kyc-header { background: linear-gradient(45deg, #1e293b, #334155); color: #fff !important; padding: 15px 20px; display: flex; flex-direction: column; gap: 10px; }
        @media (min-width: 768px) {
          .kyc-header { flex-direction: row; justify-content: space-between; align-items: center; padding: 20px 30px; }
        }

        /* MOBILE SCROLL FIX */
        .table-responsive-custom { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; background: #fff; }
        .custom-table-kyc { width: 100%; border-collapse: collapse; min-width: 950px; table-layout: auto; }
        
        .custom-table-kyc th { background: #f8f9fa; color: #334155 !important; padding: 12px; font-weight: 800; text-transform: uppercase; font-size: 0.7rem; border-bottom: 2px solid #edf2f7; text-align: center; white-space: nowrap; }
        .custom-table-kyc td { padding: 12px; vertical-align: middle; border-bottom: 1px solid #f1f1f1; font-size: 0.8rem; color: #000 !important; text-align: center; font-weight: 500; white-space: nowrap; }
        
        .kyc-img-thumb { width: 45px; height: 45px; object-fit: cover; border-radius: 8px; cursor: pointer; border: 2px solid #e2e8f0; transition: 0.3s; }
        .kyc-img-thumb:hover { transform: scale(1.1); border-color: #57155a; }
        
        .badge-pending { background: #fff3e0; color: #e65100; padding: 5px 10px; border-radius: 8px; font-weight: 700; font-size: 0.7rem; }
        
        .btn-approve { background: #15803d; color: white !important; border-radius: 8px; font-weight: 700; font-size: 0.7rem; padding: 8px 12px; border: none; transition: 0.3s; }
        .btn-reject { background: #be123c; color: white !important; border-radius: 8px; font-weight: 700; font-size: 0.7rem; padding: 8px 12px; border: none; transition: 0.3s; }
        .btn-approve:hover, .btn-reject:hover { opacity: 0.9; transform: translateY(-1px); }

        /* MODAL RESPONSIVE */
        .image-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.9); display: flex; justify-content: center; align-items: center; z-index: 9999; padding: 15px; }
        .modal-content-box { position: relative; width: 100%; max-width: 500px; animation: zoomIn 0.3s ease; }
        .modal-content-box img { width: 100%; border-radius: 12px; box-shadow: 0 0 20px rgba(0,0,0,0.5); }
        .close-modal { position: absolute; top: -40px; right: 0; color: white; font-size: 30px; cursor: pointer; background: none; border: none; }
        
        @keyframes zoomIn { from { transform: scale(0.8); opacity: 0; } to { transform: scale(1); opacity: 1; } }

        .pagination-kyc .page-link { padding: 6px 12px; font-size: 0.8rem; border-radius: 8px !important; margin: 0 3px; border: none; background: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
        .pagination-kyc .page-item.active .page-link { background: #57155a !important; color: #fff !important; }
      `}</style>

      <h3 className="mb-3" style={{fontWeight: 900, color: '#1e293b', fontSize: '1.2rem'}}>KYC <span style={{color: '#57155a'}}>Panel</span></h3>

      <div className="kyc-card">
        <div className="kyc-header">
          <h4 className="m-0" style={{fontWeight: 800, fontSize: '1rem'}}>Pending Verification</h4>
          <select className='form-control form-control-sm' style={{width: '150px', borderRadius: '8px', fontWeight: 'bold'}} onChange={setpageLimit}>
            <option value="10">Limit: 10</option>
            <option value="20">20 Items</option>
            <option value="50">50 Items</option>
          </select>
        </div>

        <div className="table-responsive-custom">
          <table className="custom-table-kyc">
            <thead>
              <tr>
                <th>#</th>
                <th>Profile Name</th>
                <th>Aadhar Name</th>
                <th>Phone</th>
                <th>Aadhar No.</th>
                <th>Front Image</th>
                <th>Back Image</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item._id}>
                  <td style={{color: '#64748b'}}>#{(pageNumber - 1) * limit + (index + 1)}</td>
                  <td>
                    <Link className="btn btn-sm py-1 px-2" style={{background: '#f1f5f9', color: '#1e293b', fontWeight: '700', borderRadius: '6px', fontSize: '0.75rem'}} to={`/user/view_user/${item.User?._id}`}>
                      {item.User ? item.User.Name : 'Unknown'}
                    </Link>
                  </td>
                  <td style={{fontWeight: '700'}}>{item.Name}</td>
                  <td>{item.User ? item.User.Phone : 'N/A'}</td>
                  <td style={{fontFamily: 'monospace', fontWeight: '700', color: '#57155a'}}>{item.Number}</td>
                  <td>
                    <OptimizedImage 
                      src={`${baseUrl}${item.front}`} 
                      className="kyc-img-thumb" 
                      alt="Front" 
                      width="45px"
                      height="45px"
                      onClick={() => setPreviewImage(`${baseUrl}${item.front}`)} 
                    />
                  </td>
                  <td>
                    <OptimizedImage 
                      src={`${baseUrl}${item.back}`} 
                      className="kyc-img-thumb" 
                      alt="Back" 
                      width="45px"
                      height="45px"
                      onClick={() => setPreviewImage(`${baseUrl}${item.back}`)} 
                    />
                  </td>
                  <td><span className="badge-pending">{item.verified}</span></td>
                  <td style={{fontSize: '0.7rem', color: '#64748b'}}>{dateFormat(item.createdAt)}</td>
                  <td>
                    <div className="d-flex justify-content-center gap-1">
                      <button className="btn-approve" onClick={() => updateStatus(item._id, "verified")}>APPROVE</button>
                      <button className="btn-reject" onClick={() => updateStatus(item._id, "reject")}>REJECT</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='p-3'>
          <ReactPaginate
            previousLabel={"←"}
            nextLabel={"→"}
            pageCount={numberOfPages}
            onPageChange={handlePageClick}
            containerClassName={"pagination pagination-kyc justify-content-center flex-wrap"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link shadow-sm"}
            activeClassName={"active"}
            forcePage={pageNumber - 1}
          />
        </div>
      </div>

      {/* --- IMAGE PREVIEW MODAL (MOBILE RESPONSIVE) --- */}
      {previewImage && (
        <div className="image-modal-overlay" onClick={() => setPreviewImage(null)}>
          <div className="modal-content-box" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setPreviewImage(null)}>×</button>
            <img src={previewImage} alt="KYC Full Preview" />
            <div className="text-center mt-3">
                <a href={previewImage} download className="btn btn-light btn-sm" style={{fontWeight: 'bold', fontSize: '0.75rem'}}>Download Image</a>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}